import { createBookingApiClient } from "@openings/api-client";

const noStoreFetch: typeof fetch = (input, init) => {
  const fetchImpl = globalThis.fetch;
  if (typeof fetchImpl !== "function") {
    throw new Error("Fetch API is not available in this environment");
  }

  return fetchImpl(input as any, {
    ...(init ?? {}),
    cache: "no-store",
  });
};

export const openingsProxyClient = createBookingApiClient("/api", {
  fetchImpl: noStoreFetch,
});
